export enum HiddenItemType {
	DASHBOARDS = 'dashboards',
	METRICS = 'metrics',
	FILTERS = 'filters',
	ATTRIBUTES = 'attributes',
	MODELS = 'models',
	DRIVERS = 'drivers'
}

